import React from 'react';
import { getRankDisplay } from 'config/constants';
import './RankPrefix.css';

/** Medal emoji (1–3) or muted `#N` before a profile name. */
export const RankPrefix: React.FC<{ rank: number }> = ({ rank }) => {
  if (rank < 1) return null;
  const isMedal = rank <= 3;
  return <span className={isMedal ? 'rank-prefix rank-prefix--medal' : 'rank-prefix'}>{getRankDisplay(rank)}</span>;
};
